export function canBroadcast() {
  return typeof BroadcastChannel !== 'undefined'
}

export const LUX_BROADCAST_CHANNEL = 'luxcast'
